import React, { useState } from 'react'
import Modal from '../../common/Modal'
import UploadField from '../../common/UploadField'
import SubmitButton from '../../common/SubmitButton'

type Props = {
  createImport: (census_import: FormData) => void
}

const CensusImport: React.FC<Props> = ({ createImport }) => {
  const [closeModal, setCloseModal] = useState(false)
  const [fileName, setFileName] = useState(undefined)
  const [file, setFile] = useState<File>()

  const handleOpen = () => {
    setCloseModal(true)
  }

  const handleClose = () => {
    setCloseModal(false)
  }

  const handleFile = (_field: string, value: string, binaryFile: File) => {
    setFileName(value)
    setFile(binaryFile)
  }

  const handleSubmit = (event: React.FormEvent) => {
    const formData = new FormData()
    formData.append('census_import[file]', file as File, fileName)
    createImport(formData)
    setCloseModal(false)
  }

  return (
    <>
      <button
        className="census-import pure-button pure-input-1 pure-button-secondary small inline-right"
        title="Import Census"
        onClick={handleOpen}
        disabled={false}
      >
        Import Census
      </button>

      {closeModal
        && (
          <Modal
            handleClose={handleClose}
            className="modal"
          >
            <form className="pure-form pure-form-stacked" onSubmit={handleSubmit}>
              <h2>Import census</h2>

              <p>Upload a CSV file and we´ll build the census for you.</p>

              <fieldset className="buffer-bottom">
                <UploadField
                  key="file"
                  name="census_file"
                  id="census_file"
                  label="CSV file"
                  handleChange={handleFile}
                  value={fileName}
                  disabled={false}
                />
              </fieldset>

              <fieldset>
                <SubmitButton
                  title="Submit"
                  text="Submit"
                  loading={false}
                />
              </fieldset>
            </form>
          </Modal>
        )}
    </>
  )
}

export default CensusImport
